import { Paginated, QueryParamsType, normalizeQueryParams } from "api/utils";

import request, { APICall } from "../request";
import {
  EditOrganisationType,
  NewOrganisationPayloadType,
  OrganisationsType,
} from "./types";

export const getOrganisations = (
  queryParams?: QueryParamsType<OrganisationsType>,
): APICall<Paginated<OrganisationsType[]>> =>
  request({
    url: `/organisation${normalizeQueryParams(queryParams)}`,
    method: "GET",
  });

export const getSingleOrganisation = (
  organisationId: string,
): APICall<{ data: OrganisationsType }> =>
  request({
    url: `/organisation/${organisationId}`,
    method: "GET",
  });

export const addOrganisation = (
  organisation: NewOrganisationPayloadType,
): APICall<OrganisationsType> =>
  request({
    data: organisation,
    url: "/organisation",
    method: "POST",
  });

export const editOrganisation = (
  organisation: EditOrganisationType,
): APICall<OrganisationsType> =>
  request({
    data: organisation,
    url: `/organisation/${organisation._id}`,
    method: "PUT",
  });

export const deleteOrganisation = (organisationId: string): APICall<null> =>
  request({
    url: `/organisation/${organisationId}`,
    method: "DELETE",
  });
